export enum ReconOverviewTypes {
  MERCHANT = 0,
  POS_DEVICE = 1,
  POS_DEVICE_KIOSK = 2,
  KIOSK = 3,
  INTEGRATIONS = 4,
  OTHER = 5,
  TOTAL = 6,
  SWEET_FACE_TERMINAL = 7,
}